<template>
    <detail-layout-full-width>
        <template slot="header">
            <BaseHeader :content="header" />
        </template>
        <template slot="main">
          <div class="form-wrapper">
            <el-form
              :model="form"
              :rules="rules"
              ref="ruleForm"
            >
              <div class="lg:mb-2" >
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('companies.configuration_recobro.platfrom') }}</label>
                <div class="flex justify-between">
                  <el-form-item prop="plataforma" class="w-full">
                    <base-el-select class="w-full" :options="tiposPlataformaRecobro" v-model="form.plataforma" filterable clearable :loading="isGeneralLoading" />
                  </el-form-item>
                </div>
              </div>

              <div v-if="!isStripe" class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('clients.id_client') }}</label>
                <el-form-item prop="ClienteId" ref="ClienteId">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.ClienteId"
                    maxlength='80'
                  />
                </el-form-item>
              </div>

              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('clients.api_keys.secret') }}</label>
                <el-form-item prop="Secreto" ref="Secreto">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Secreto"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </template>
        <template slot="layout-extend">
          <base-footer>
            <template slot="actions">
              <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
                :loading="isGeneralLoading" />
              <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
                :loading="isGeneralLoading" :disabled="isGeneralLoading" />
            </template>
          </base-footer>
        </template>
    </detail-layout-full-width>
</template>
<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'

import { getCompany } from '@/services/companies/getCompany'
import { guardarInformacionCobro } from '@/services/companies/guardarInformacionCobro'
import { getInformacionCobro } from '@/services/companies/getInformacionCobro'

import { i18n } from '@/i18n'

export default {
  components: {
    DetailLayoutFullWidth
  },
  data () {
    return {
      header: {
        title: i18n.t('companies.configuration_recobro.recobro_config'),
        icon: 'companies',
        breadcrumb: {},
        url: 'companies/detail'
      },
      form: {
        plataforma: '',
        ClienteId: '',
        Secreto: '',
      },
      maxCharStripeSecret: 250,
      maxCharPaypalSecret: 350,
      rules: {
        plataforma: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['change', 'blur'],
          },
        ],
        ClienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['change', 'blur'],
          },
        ],
        Secreto: [
          {
            required: true,
            trigger: ['change', 'blur'],
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                return callback(new Error(i18n.t('app.fill_data')))
              } else if (this.isStripe && value.length > this.maxCharStripeSecret) {
                return callback(new Error(i18n.t('companies.configuration_recobro.validation_secret', { maxCharacters: this.maxCharStripeSecret })))
              } else if (value.length > this.maxCharPaypalSecret) {
                return callback(new Error(i18n.t('companies.configuration_recobro.validation_secret', { maxCharacters: this.maxCharPaypalSecret })))
              }
              callback()
            }
          },
        ],
      },
    }
  },
  async mounted () {
    this.form.idCIFEmpresa = this.$route.params.id

    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: i18n.t('companies.header') })
    
    const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
    if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
      breadcrumbs.push({ path: '', name: cabeceraStored })
    } else {
      const company = await this.getCompanyData(this.companyId)
      breadcrumbs.push({ path: '', name: company.RazonSocial })
      this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)
    }
    this.header.breadcrumb = breadcrumbs

    await this.getCobroData(this.companyId)
  },
  computed: {
    companyId: function () {
      return this.$route.params.id
    },
    isStripe: function () {
      return this.form.plataforma === 1
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    tiposPlataformaRecobro: function () {
      return this.$store.getters['config/TIPOS_RECOBRO']
    },
  },
  methods: {
    getCobroData: async function (companyId) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await getInformacionCobro({ idCifEmpresa: companyId })
        if (!response.blnError) {
          this.setConfig(response.Respuesta)
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getCompanyData: async function (idCIFEmpresa) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: idCIFEmpresa }
        const company = await getCompany(params)
        if (!company.blnError) {
          return company.CIFEmpresa
        }
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', company))
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setConfig: function (data) {
      this.form.plataforma = data.Plataforma ?? ''
      this.form.ClienteId = data.clientId ?? ''
      this.form.Secreto = data.secretId ?? ''
    },
    submitForm: async function (formName) {
      this.$store.commit('setIsLoading', true)
      setTimeout(() => {
        try {
          this.$refs[formName].validate(async valid => {
            if (valid) {
              const params = {
                Plataforma: this.form.plataforma,
                clientId: this.form.ClienteId,
                secretId: this.form.Secreto,
                idCifEmpresa: parseInt(this.companyId)
              }
              const response = await guardarInformacionCobro(params)
              if (response && response.blnError === false) {
                this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              } else {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              }
            } else {
              this.doFeedback(i18n.t('feedback.error.process_data_error'))
            }
          })
        } catch (error) {
          this.doFeedback(error)
        } finally {
          this.$store.commit('setIsLoading', false)
        }
      }, 100)
    },
    goBack: function () {
      this.$router.push({ name: 'companies' })
    }
  }
}
</script>
